import React from 'react';

import { getOwnerList } from '@/services/ws-orders/src/main/resources/rest-api';
import { useSubscribe } from '@/js/libs/observable';
import { useRequest } from '@/js/libs/use-request';

import { DEFAULT_DEBOUNCE_DELAY, DROP_DOWN_ENTITY_LIMIT } from 'src/constants';
import type { Option } from 'src/types';

type UseOwnersOptionsReturn = {
  options: Option<string>[];
  pending: boolean;
  total: number;
  searchFilter: string;
  setSearchFilter: (filter: string) => void;
};

type UseOwnersOptions = () => UseOwnersOptionsReturn;

export const useOwnersOptions: UseOwnersOptions = () => {
  const [searchFilter, setSearchFilter] = React.useState<string>('');

  const getOwnerListRequest = useRequest({
    apiMethod: getOwnerList,
    params: { prefix: searchFilter, limit: DROP_DOWN_ENTITY_LIMIT, page: 0 },
    debounce: DEFAULT_DEBOUNCE_DELAY,
  });

  const options = useSubscribe(
    getOwnerListRequest.data$,
    (response) =>
      response?.data.items.map((item) => ({
        label: item?.name ?? '',
        value: item.ownerId ?? '',
      })) ?? [],
  );
  const total = useSubscribe(getOwnerListRequest.data$, (result) => result?.data.total ?? 0);
  const pending = useSubscribe(getOwnerListRequest.pending$);

  return React.useMemo<UseOwnersOptionsReturn>(
    () => ({
      options,
      pending,
      total,
      searchFilter,
      setSearchFilter,
    }),
    [options, pending, total, searchFilter],
  );
};
